module.exports = __webpack_public_path__ + "static/404-b3fb78fd84d1947cb63223ede14b38bd.gif";